export default function ({ route, redirect }) {
  // Check if the current route has a trailing slash
  if (route.path.slice(-1) === '/') {
    // Remove the trailing slash
    const newPath = route.path.slice(0, -1)
    // Redirect to the same route without the trailing slash
    return redirect(newPath)
  }
}
